import { makeStyles } from '@material-ui/core';

export const useBadgeStyles = makeStyles({
  root: {
    width: 'fit-content',
    // Keep the pill intact when rendered inline next to a shrinking text.
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    color: 'white',
    borderRadius: 16,
    padding: '4px 10px',
    boxShadow: '0px 2px 4px 0px #30363C29',
    background: '#1E96FC'
  },
  small: {
    gap: 3,
    padding: '1px 6px'
  },
  icon: {
    fontSize: 16
  },
  iconSmall: {
    fontSize: 12
  }
});
